<script>
export default {
  created() {
    const target = this.$route.query.target ? { path: this.$route.query.target } : Object.values(this.$parent.$children[0].menus||[])[0];
    if (target) this.$router.replace(target.path);
    else this.$store.commit('user');
  },
}
</script>